export const createReducer =
	(initialState, handlers) =>
	(state = initialState, action) => {
		if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
			return handlers[action.type](state, action.payload);
		}
		return state;
	};

export const removeEmpty = (obj) => {
	const o = JSON.parse(JSON.stringify(obj));
	if (o === null || o === undefined) {
		return o;
	}
	Object.keys(o).forEach((key) => {
		if (o[key] && typeof o[key] === "object") {
			o[key] = removeEmpty(o[key]);
		} else if (o[key] === undefined || o[key] === null) {
			delete o[key];
		} else {
			o[key] = o[key];
		}
	});

	return o;
};

export const removeTypename = (obj) => {
	if ("file" in obj) {
		return obj;
	}
	const o = JSON.parse(JSON.stringify(obj));
	if ("__typename" in o) {
		delete o.__typename;
	}
	Object.keys(o).forEach((key) => {
		if (o[key] && typeof o[key] === "object") {
			o[key] = removeTypename(o[key]);
		} else {
			o[key] = o[key];
		}
	});

	return o;
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js